import {Component, Input} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';

@Component({
    template: ''
})
// tslint:disable-next-line:component-class-suffix
export abstract class CustomFormControl {
    control: FormControl = new FormControl();
    @Input('control') set _control(control: AbstractControl) {
        this.control = control as FormControl;
    }
    public size: string;

    get errors() {
        return this.control
        && this.control.errors
        && Object.keys(this.control.errors).length
            ? Object.keys(this.control.errors)
            : null;
    }

    get classNames() {
        const cn = {'is-invalid': this.errors};
        if (this.size && ['full', 'half', 'quarter'].includes(this.size.toString())) {
            cn[`form-control__${this.size}`] = true;
        }
        return cn;
    }
}
